var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloisonsPlafond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5935 16.7507V36.5121",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1091 17.4649L53.8492 14.519",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1931 10.4271L28.689 14.3794",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9835 6.40707L20.965 12.2339",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2407 2.52264L20.7843 8.84629",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0413 10.2917L47.1856 2.52264",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.998 16.1943L28.059 6.01675",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4027 15.3968L36.9908 3.02809",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9927 20.4506V45.3763",
    stroke: "#A3AED0",
    strokeWidth: 0.599817
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99878 13.6525V38.5782",
    stroke: "#A3AED0",
    strokeWidth: 0.599817
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99695 17.0515V22.8029C9.99695 26.0827 12.2261 28.9428 15.4065 29.7438V29.7438M18.9942 43.1102V34.3471C18.9942 32.1719 17.5158 30.2751 15.4065 29.7438V29.7438M15.4065 29.7438C15.4065 25.2296 15.4065 18.1845 15.4065 18.1845L17.9945 19.3175C17.9945 19.3175 17.9945 26.9133 17.9945 31.7804",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9948 32.9133C16.9948 32.2876 16.771 31.7804 16.495 31.7804C16.2189 31.7804 15.9951 32.2876 15.9951 32.9133C15.9951 33.5391 16.2189 34.0463 16.495 34.0463C16.771 34.0463 16.9948 33.5391 16.9948 32.9133Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9948 37.4453C16.9948 36.8195 16.771 36.3123 16.495 36.3123C16.2189 36.3123 15.9951 36.8195 15.9951 37.4453C15.9951 38.071 16.2189 38.5782 16.495 38.5782C16.771 38.5782 16.9948 38.071 16.9948 37.4453Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 13.6526V38.5783L25.9922 46.5092M1.99951 13.6526L7.99768 12.5196L31.9903 20.4505M1.99951 13.6526L25.9922 21.5835M25.9922 46.5092V21.5835M25.9922 46.5092L31.9903 45.3762V20.4505M25.9922 21.5835L31.9903 20.4505",
    stroke: "#A3AED0",
    strokeWidth: 2.07936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9887 36.5123V17.5181L19.9939 11.5199",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.523315)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloisonsPlafond);
export default __webpack_public_path__ + "static/media/CloisonsPlafond.025dfbea5b5ab3a8294527ee85f07dca.svg";
export { ForwardRef as ReactComponent };